export enum AccountStatusEnum {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
  Deactivated = 'DEACTIVATED',
  Onboarding = 'ONBOARDING',
}
